import gql from 'graphql-tag'

import { AppUnregisterMutation } from '../../../types/api'

export const unregister = {
  mutation: gql`
    mutation AppUnregister($token: String!) {
      peUnregister(token: $token) {
        id
      }
    }
  `,
  transformer: (response: AppUnregisterMutation) => {
    return response.peUnregister
  },
}
